// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter {\n    opacity: 0;\n}\n.fade-enter-active {\n    transition: opacity 1s;\n}\n.fade-leave {\n    /* opacity: 1; */\n}\n.fade-leave-active {\n    transition: all 1s;\n    opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
